import type React from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { StyledGradientButton, StyledRectangle, StyledGradientButtonText, StyledGradientRectangle } from "./styles";
import type { GradientButtonVariant } from "./types";

type GradientButtonProps = {
    variant: GradientButtonVariant;
    onClick: () => void;
    disabled?: boolean;
    dataAutomation?: string;
};

const renderIconByVariant = (variant: GradientButtonVariant) => {
    switch (variant) {
        case "generate":
            return (
                <SWReactIcons
                    iconName="spark-ai"
                    size="xs"
                    iconColor={colorsPalettes.carbon[0]}
                />
            );
        case "submit":
            return (
                <SWReactIcons
                    iconName="arrow-up-grey"
                    size="sm"
                    iconColor={colorsPalettes.carbon[0]}
                />
            );
        case "locked":
            return <StyledRectangle />;
        case "disabled":
            return (
                <SWReactIcons
                    iconName="arrow-up-grey"
                    size="sm"
                    iconColor={colorsPalettes.carbon[0]}
                />
            );
        case "ghost":
            return (
                <SWReactIcons
                    iconName="sparkles-gradient"
                    size="xs"
                />
            );
        case "flat":
            return (
                <SWReactIcons
                    iconName="arrow-up-gradient"
                    size="xs"
                    className="send-button"
                />
            );
        case "flatRectangle":
            return <StyledGradientRectangle data-automation="pause-button" />;
        case "ghostSmall":
            return (
                <SWReactIcons
                    iconName="ai-search"
                    size="xs"
                />
            );
        default:
            return null;
    }
};

const GradientButton: React.FC<React.PropsWithChildren<GradientButtonProps>> = ({
    variant,
    onClick,
    children,
    disabled,
    dataAutomation,
}) => {
    return (
        <StyledGradientButton
            variant={variant}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            data-automation={dataAutomation}
        >
            {renderIconByVariant(variant)}
            {variant === "ghost" || variant === "ghostSmall" ? (
                <StyledGradientButtonText>{children}</StyledGradientButtonText>
            ) : (
                children
            )}
        </StyledGradientButton>
    );
};

export default GradientButton;
